export default "__VITE_ASSET__C0m9cfPk__"